/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/DialogFlowSession'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/DialogFlowSession'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DialogFlowSessionApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.DialogFlowSession);
  }
}(this, function(ApiClient, DialogFlowSession) {
  'use strict';

  /**
   * DialogFlowSession service.
   * @module api/DialogFlowSessionApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new DialogFlowSessionApi. 
   * @alias module:api/DialogFlowSessionApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the dialogFlowSessionCreatePreviewSessionGet operation.
     * @callback module:api/DialogFlowSessionApi~dialogFlowSessionCreatePreviewSessionGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DialogFlowSession} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * createPreviewSession
     * @param {String} _4SAPIAppID 
     * @param {Integer} templateID 
     * @param {Boolean} useSystemTemplate 
     * @param {module:api/DialogFlowSessionApi~dialogFlowSessionCreatePreviewSessionGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DialogFlowSession}
     */
    this.dialogFlowSessionCreatePreviewSessionGet = function(_4SAPIAppID, templateID, useSystemTemplate, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dialogFlowSessionCreatePreviewSessionGet";
      }

      // verify the required parameter 'templateID' is set
      if (templateID == undefined || templateID == null) {
        throw "Missing the required parameter 'templateID' when calling dialogFlowSessionCreatePreviewSessionGet";
      }

      // verify the required parameter 'useSystemTemplate' is set
      if (useSystemTemplate == undefined || useSystemTemplate == null) {
        throw "Missing the required parameter 'useSystemTemplate' when calling dialogFlowSessionCreatePreviewSessionGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'templateID': templateID,
        'useSystemTemplate': useSystemTemplate
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = DialogFlowSession;

      return this.apiClient.callApi(
        '/DialogFlowSession/createPreviewSession', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dialogFlowSessionLoadGet operation.
     * @callback module:api/DialogFlowSessionApi~dialogFlowSessionLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DialogFlowSession} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/DialogFlowSessionApi~dialogFlowSessionLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DialogFlowSession}
     */
    this.dialogFlowSessionLoadGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dialogFlowSessionLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling dialogFlowSessionLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = DialogFlowSession;

      return this.apiClient.callApi(
        '/DialogFlowSession/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
